<template>
  <div>
    <div class="main">
      <div class="board" v-for="(item, index) in totalBoxOfficeList" :key="item.movieId">
        <div class="left">
          <i class="board-index">{{index+1}}</i>
        </div>
        <div class="middle1">
          <router-link :to="'/movieInfo/' + item.movieId">
            <img :src="global.base + JSON.parse(item.moviePoster)[0]" :alt="item.movieName">
          </router-link>
        </div>
        <div class="middle2">
          <router-link :to="'/movieInfo/' + item.movieId"><p class="name">{{ item.movieName }}</p></router-link>
          <p class="releaseTime">上映时间：{{ item.releaseDate.split(" ")[0] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TotalBoxOfficeList",
  data(){
    return{
      queryInfo:{
        pageNum: 1,
        pageSize: 10
      },
      totalBoxOfficeList: [],
      refreshInterval: 30, // 默认30秒
      refreshTimer: null
    }
  },
  created() {
    this.getRefreshInterval()
    this.getTotalBoxOfficeList()
    this.startAutoRefresh()
  },
  beforeDestroy() {
    this.stopAutoRefresh()
  },
  methods:{
    async getTotalBoxOfficeList(){
      const {data: resp} = await axios.get('sysMovie/find/rankingList/1', {params: this.queryInfo})
      console.log(resp)
      if(resp.code !== 200) return this.$message.error(resp.msg)
      this.totalBoxOfficeList = resp.data
    },

    async getRefreshInterval() {
      try {
        const { data: resp } = await axios.get('sysConfig/boxOfficeRefreshInterval')
        if (resp.code === 200 && resp.data) {
          const newInterval = resp.data
          // 如果间隔发生变化，重新启动定时器
          if (this.refreshInterval !== newInterval) {
            console.log(`票房刷新间隔从 ${this.refreshInterval}秒 更新为 ${newInterval}秒`)
            this.refreshInterval = newInterval
            this.restartAutoRefresh()
          }
        }
      } catch (error) {
        console.error('获取票房刷新间隔失败:', error)
        // 使用默认值30秒
        this.refreshInterval = 30
      }
    },

    startAutoRefresh() {
      // 清除可能存在的定时器
      this.stopAutoRefresh()
      
      // 设置新的定时器
      this.refreshTimer = setInterval(() => {
        console.log('自动刷新票房排行榜数据...')
        this.getTotalBoxOfficeList()
        // 每次刷新后检查配置是否有更新
        this.getRefreshInterval()
      }, this.refreshInterval * 1000)
    },

    restartAutoRefresh() {
      console.log(`重启票房自动刷新，新间隔：${this.refreshInterval}秒`)
      this.stopAutoRefresh()
      this.startAutoRefresh()
    },

    stopAutoRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    }
  }
}
</script>

<style scoped>
.main{
  width: 950px;
  margin: 0 auto;
  margin-top: 70px;
  padding-bottom: 24px;
}

.board{
  display: flex;
  margin: 25px 0;
}

.left{
  display: flex;
  align-items: center;
  margin-right: 25px;
}

.middle1{
  display: flex;
  align-items: center;
}

.middle2{
  display: flex;
  /*align-items: center;*/
  flex-direction: column;
  justify-content: center;
  margin-left: 25px;
  width: 300px;
}

.middle2 > a {
  color: #373d41;
  font-size: 26px;
  text-decoration: none;
}

.name, .star, .releaseTime{
  margin-top: 8px;
  margin-bottom: 8px;
}

.releaseTime{
  color: #999999;
}

.right{
  display: flex;
  font-size: 40px;
  font-weight: 700;
  font-style: italic;
  color: #ffb400;
  margin-left: 320px;
  align-items: center;
}

.board-index{
  background: #ffb400;
  color: #fff;
  display: inline-block;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  align-items: center;
}

img{
  width: 160px;
  height: 220px;
}

@media (max-width: 768px) {
  .main{
    width: 100%;
    margin-top: 0;
    padding: 16px;
  }

  .board{
    margin: 0 0 16px;
    padding: 14px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    align-items: flex-start;
  }

  .left{
    margin-right: 14px;
    flex-shrink: 0;
  }

  .board-index{
    width: 36px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }

  .middle1{
    flex-shrink: 0;
  }

  .middle2{
    width: auto;
    min-width: 0;
    margin-left: 14px;
    flex: 1;
  }

  .middle2 > a{
    font-size: 20px;
    line-height: 1.4;
  }

  .name{
    margin-top: 0;
    white-space: normal;
    word-break: break-word;
  }

  .releaseTime{
    line-height: 1.5;
  }

  img{
    width: 92px;
    height: 126px;
    object-fit: cover;
  }
}
</style>
